import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advancedFormat);

export const convertToDate = dateStr => {
    const date = dayjs(dateStr);
    return date.toDate();
};

export const customizeDateFormat = (dateStr, pattern) => {
    const date = dayjs(dateStr).format(pattern);
    return date;
};

export const formatDate = date => {
    return dayjs(date).format('MMM DD, YYYY');
};

export const formatEventDate = (eventDateTime, is_date) => {
    if (!eventDateTime) {
        return '';
    }
    const dateInGMT = dayjs.utc(eventDateTime).tz('America/New_York');
    if (is_date) return dateInGMT.format('MMM DD, YYYY');
    else if (eventDateTime) return dateInGMT.format('hh:mm A [[EST]]');
    else return null;
};

export const formatTrackingAddress = (EventCity, EventState, EventZIPCode) => {
    let address = '';
    if (EventCity) address = `${address} ${EventCity}`;
    if (EventZIPCode) address = `${address} ${EventZIPCode}`;
    if (EventState) address = `${address} ${EventState}`;

    return address;
};

export const formatAddress = address => {
    let formatedAddress = '';
    if (!address) {
        return formatedAddress;
    }

    if (address.line1) {
        formatedAddress += `${address.line1}`;
    }
    if (address.line2) {
        formatedAddress += `, ${address.line2}`;
    }
    if (address.city) {
        formatedAddress += `, ${address.city}`;
    }
    if (address.state) {
        formatedAddress += `, ${address.state}`;
    }
    if (address.country) {
        formatedAddress += `, ${address.country}`;
    }
    if (address.zip) {
        formatedAddress += `, ${address.zip}`;
    }
    return formatedAddress;
};

export const formatAddressContact = address => {
    let formatedAddressContact = '';
    if (!address) {
        return formatedAddressContact;
    }

    if (address.contact_mobile_number) {
        formatedAddressContact += `M: ${address.contact_mobile_number}`;
    }
    if (address.contact_office_number) {
        formatedAddressContact += `, O: ${address.contact_office_number}`;
    }
    if (address.contact_email) {
        formatedAddressContact += `, E: ${address.contact_email}`;
    }
    return formatedAddressContact;
};

export const dateTimeFormat = datetime => {
    return datetime ? dayjs(datetime).format('MMM DD, YYYY hh:mm A') : '';
};

export const dateFormat = datetime => {
    return datetime ? dayjs(datetime).format('MMM DD, YYYY') : '';
};

export const dateFormatDob = datetime => {
    return datetime ? dayjs(datetime).format('YYYY-MM-DD') : '';
};

export const titleCase = text => {
    try {
        return text ? text[0].toUpperCase() + text.slice(1).toLowerCase() : '';
    } catch (error) {
        console.log(text);
        console.log(error);
        return text;
    }
};

export const customTableStyles = {
    headCells: {
        style: {
            backgroundColor: '#d4d0d0',
            fontSize: '13px',
        },
    },
    expanderButton: {
        style: {
            backgroundColor: '#007bff',
            color: '#fff',
        },
    },
};

export const showPhenoTypes = phenoTypes => {
    return Object.keys(phenoTypes).length > 0
        ? Object.entries(phenoTypes).map(val => {
              const score =
                  Object.keys(phenoTypes).length === 2
                      ? Math.round(parseFloat(val[1]['score']) * 100)
                      : parseFloat(val[1]['score']).toFixed(4);
              return (
                  <span
                      key={val[1]['label']}
                      style={{
                          margin: '2px',
                          minWidth: '75px',
                      }}>
                      {val[1]['label']}({score})
                  </span>
              );
          })
        : '';
};

export const customTableStylesAccountView = {
    headCells: {
        style: {
            backgroundColor: '#ffffff',
            fontSize: '13px',
        },
    },
};
